import { useNavigate } from 'react-router';

import { FullPageMessage } from '@/shared/ui/feedback/FullPageMessage';

export const SharedDashboardExpired = () => {
  const navigate = useNavigate();

  return (
    <FullPageMessage
      buttonLabel='Go to Homepage'
      subtitle='Dashboard share links are only valid for 30 days. If you still need access, please ask the sender to share it again.'
      title='This link has expired'
      onButtonClick={() => {
        navigate('/');
      }}
    />
  );
};
